import { getGoToTodayMenuItem } from '../commandBarItems/getGoToTodayMenuItem';
import { getSurfaceShareMenuItem } from '../commandBarItems/surface/getSurfaceShareMenuItem';
import { getViewSwitcherMenuItem } from '../commandBarItems/getViewSwitcherMenuItem';
import { CalendarModuleCommandBarConfig } from '../schema';
import { getSurfaceNavigationMenuItems } from '../commandBarItems/surface/getSurfaceNavigationMenuItems';
import { getSurfacePrintMenuItem } from '../commandBarItems/surface/getSurfacePrintMenuItem';
import { getSurfaceTimestripMenuItem } from '../commandBarItems/surface/getSurfaceTimestripMenuItem';

export function getSurfaceCommandBarConfig(
    onCustomRenderSubMenuChange: () => void
): CalendarModuleCommandBarConfig {
    return {
        primaryItems: [
            getGoToTodayMenuItem(),
            ...getSurfaceNavigationMenuItems(),
            getSurfaceTimestripMenuItem(),
        ],
        farItems: [
            getViewSwitcherMenuItem(onCustomRenderSubMenuChange),
            getSurfaceShareMenuItem(),
            getSurfacePrintMenuItem(),
        ],
    };
}
